export default "__VITE_ASSET__BVVutdIT__"